var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},_vm._l((_vm.list),function(image,index){return _c('div',{key:image,staticClass:"image",class:{ active: index == _vm.active },style:({ backgroundImage: 'url(' + image + ')' })})}))}
var staticRenderFns = []

export { render, staticRenderFns }